import { io } from "socket.io-client";

// create one socket instance for the whole app
const socket = io(process.env.VUE_APP_BASE_URL, {
  transports: ["websocket"], // use websocket directly
  autoConnect: false,        // connect manually
});

let currentUserId = null;

// helper to connect with userId
function connect(userId) {
  if (!userId) return;

  currentUserId = userId;

  if (!socket.connected) {
    socket.connect();
  }

  // join room once connected
  socket.once("connect", () => {
    console.log("Socket connected:", socket.id);

    socket.emit("join", currentUserId);
    console.log("Joined room:", currentUserId);
  });
}

// helper to disconnect
function disconnect() {
  if (socket.connected) {
    socket.disconnect();
    console.log("Socket disconnected");
  }
}

// automatically rejoin room after reconnect
socket.on("reconnect", () => {
  if (currentUserId) {
    socket.emit("join", currentUserId);
    console.log("Rejoined room after reconnect:", currentUserId);
  }
});

// optional debugging
socket.on("disconnect", (reason) => {
  console.warn("Socket disconnected:", reason);
});

export { socket, connect, disconnect };